import React, { useRef } from 'react';

interface CasinoProviderBlockProps {
  handleCasinoSubProviderBlockClick: () => void;
  selected: boolean;
  index: number;
  title: string;
  providerRefs: React.MutableRefObject<{}>;
}

const CasinoProviderBlock: React.FC<CasinoProviderBlockProps> = ({
  handleCasinoSubProviderBlockClick,
  selected,
  index,
  title,
  providerRefs,
}) => {
  return (
    <div
      ref={(el) => (providerRefs.current[title] = el)}
      onClick={handleCasinoSubProviderBlockClick}
      className={`casino-provider-block ${selected ? 'selected' : ''} ${index === 0 ? 'first-child' : ''}`}
    >
      <div className="casino-filter-text">{title}</div>
    </div>
  );
};

export default CasinoProviderBlock;
